import type { TemporaryContractReasonType } from '@libs/data-access/entities'
import { useCommonAppTranslation } from '@libs/utils/translations'

type ContractReason = {
  value: TemporaryContractReasonType
  label: string
}

export const useTemporaryContractReasons = (): ContractReason[] => {
  const { t } = useCommonAppTranslation()
  return [
    {
      label: t('models.temporaryContractReason.employee_replacement'),
      value: 'employee_replacement'
    },
    {
      label: t('models.temporaryContractReason.increased_activity'),
      value: 'increased_activity'
    }
  ]
}
